module.exports = __webpack_public_path__ + "media/images/logo-red-fea729f9ee78ffdcb376d8f16ae72c27.png";